import React from 'react'
import { MainPageBox } from '../../components/DisplayHelpers/MainPageBox'
import { DownloadAppComponent } from './DownloadApp.component'
import { Box } from '@mui/material'

const DownloadAppContainer: React.FC = () => {
  return (
    <MainPageBox>
      <Box sx={{ p: 1 }}>
        <DownloadAppComponent />
      </Box>
    </MainPageBox>
  )
}

export default DownloadAppContainer
